import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";

export class LabelsMultiSelectComponent implements IController {

  selectedLabels: any;
  ngPlaceholder: any;
  isDisabled?: boolean;
  isRequired?: boolean;
  name?: string;
  onChange: Function;

  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $element) {
  }

  $onInit() {
    this._setSelectedText();
  };

  $onChanges(changes) {
    if (changes.selectedLabels && !changes.selectedLabels.isFirstChange()) {
      this._setSelectedText();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedLabelsRef = this.selectedLabels || [];
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedLabelsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'service-areas-types="ctrl.serviceTypesRef" ' +
        'is-allow-exclude-mode="ctrl.isAllowExcludeModeRef"' +
        'is-exclude-mode="ctrl.isExcludeModeRef"' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'labels';
        this.selectedLabelsRef = selectedLabelsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds, isExcludeMode?) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedLabelsRef;
        }

        this.onChange({selectedLabels: selectedIds});
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({selectedLabels: []});
  }

  private _setSelectedText() {
    let string = '';
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");

    _.forEach(this.selectedLabels, (label, i) => {
      string += label;
      if ((i + 1) < this.selectedLabels.length) {
        string += ', '
      }
    });

    var stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && ((stringWidth + 80) >= (this.$element[0].clientWidth - 30)) && !!this.selectedLabels?.length) {
      string = this.selectedLabels[0] + ` +${this.selectedLabels.length - 1}`
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.labels')
  .component('labelsMultiSelect', {
    bindings: {
      selectedLabels: '<',
      ngPlaceholder: '@?',
      isDisabled: '<?',
      isRequired: '<?',
      name: '<?',
      onChange: '&'
    },
    template: require('./labels-multi-select.html').default,
    controller: LabelsMultiSelectComponent
  });
